var $6f40c3a58f594b58$exports = {};
console.log('Hello world!');


//# sourceMappingURL=parcel-example.1dd6f75f.js.map
